// Catalogue des rapports de l'espace Agence.
// Deux rapports supplémentaires par rapport au Propriétaire : les propriétaires
// et le rapport global de l'agence. Les données proviennent exclusivement des
// modules de l'espace Agence.

import type { ReportTypeDef } from "@/components/feature/reports/types";

export const AGENCE_REPORT_TYPES: ReportTypeDef[] = [
  {
    id: "proprietaires",
    label: "Rapport des propriétaires",
    icon: "ri-user-star-line",
    description: "Propriétaires gérés avec immeubles, biens et encaissements.",
  },
  {
    id: "immeubles",
    label: "Rapport des immeubles",
    icon: "ri-building-2-line",
    description: "Immeubles par propriétaire avec biens et locataires rattachés.",
  },
  {
    id: "biens",
    label: "Rapport des biens",
    icon: "ri-home-4-line",
    description: "Biens par type, surface, loyer et statut d'occupation.",
  },
  {
    id: "locataires",
    label: "Rapport des locataires",
    icon: "ri-user-3-line",
    description: "Répertoire des locataires et logements occupés.",
  },
  {
    id: "contrats",
    label: "Rapport des contrats",
    icon: "ri-file-text-line",
    description: "Contrats par période, loyer, caution et statut.",
  },
  {
    id: "loyers",
    label: "Rapport des loyers",
    icon: "ri-wallet-3-line",
    description: "Échéances de loyer, montants dus et montants encaissés.",
  },
  {
    id: "paiements",
    label: "Rapport des paiements",
    icon: "ri-hand-coin-line",
    description: "Encaissements par date, mode de paiement et référence.",
  },
  {
    id: "impayes",
    label: "Rapport des impayés",
    icon: "ri-alert-line",
    description: "Loyers en retard ou impayés avec jours de retard et reste dû.",
  },
  {
    id: "depenses",
    label: "Rapport des dépenses",
    icon: "ri-money-cny-circle-line",
    description: "Charges par catégorie, propriétaire, immeuble et bien.",
  },
  {
    id: "maintenance",
    label: "Rapport de maintenance",
    icon: "ri-tools-line",
    description: "Interventions par priorité, statut, prestataire et coût.",
  },
  {
    id: "documents",
    label: "Rapport des documents",
    icon: "ri-folder-line",
    description: "Bibliothèque de documents par type, date et rattachement.",
  },
  {
    id: "revenus",
    label: "Rapport des revenus",
    icon: "ri-line-chart-line",
    description: "Loyers attendus, encaissés, impayés, dépenses et résultat par mois.",
  },
  {
    id: "global",
    label: "Rapport global de l'agence",
    icon: "ri-file-chart-line",
    description: "Synthèse complète : portefeuille, contrats, finances et suivi.",
  },
];